import type { Location } from "react-router-dom";
import type { FromLocationState } from "./types";
export function createFromLocationState(from: Location | undefined): FromLocationState | undefined {
    return from ? { from } : undefined;
}
